<div class="space-y-6">
    <!-- Header -->
    <div class="flex justify-between items-center">
        <h2 class="text-2xl font-bold text-gray-900">Investment Analytics</h2>
        <div class="flex space-x-3">
            <!-- <select [(ngModel)]="selectedPeriod" (change)="onPeriodChange(selectedPeriod)" class="px-4 py-2 text-gray-800 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500">
                <option *ngFor="let period of periods" [value]="period">
                    {{ period }}
                </option>
            </select> -->
<!-- 
            <button (click)="onExportReport()" class="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors flex items-center">
                <i-lucide name="download" class="h-4 w-4 mr-2"></i-lucide>
                Export Report
            </button> -->
        </div>
    </div>

    <!-- Loading / Error States -->
    <div *ngIf="loading" class="text-center text-gray-600">Loading analytics...</div>
    <div *ngIf="!loading && error" class="text-center text-red-600">{{ error }}</div>

    <!-- Portfolio Allocation and Risk Assessment -->
    <div *ngIf="!loading && !error" class="grid grid-cols-1 lg:grid-cols-2 gap-8">

        <!-- Portfolio Allocation -->
        <div class="bg-white rounded-xl shadow-sm p-6">
            <h3 class="text-lg font-semibold text-gray-900 mb-6">Portfolio Allocation</h3>
            <div class="space-y-4" *ngIf="allocation?.length; else noAllocation">
                <div *ngFor="let item of allocation; trackBy: trackByName">
                    <div class="flex justify-between items-center mb-2">
                        <span class="text-sm font-medium text-gray-700">{{ item.portfolioName }}</span>
                        <span class="text-sm text-gray-600">{{ item.percentage | number:'1.0-1' }}%</span>
                    </div>
                    <div class="w-full bg-gray-200 rounded-full h-2">
                        <div class="bg-gradient-to-r from-amber-400 to-amber-600 h-2 rounded-full" [style.width.%]="item.percentage">
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noAllocation>
                <div class="text-gray-500">No allocation data available.</div>
            </ng-template>
        </div>

        <!-- Risk Assessment -->
        <div class="bg-white rounded-xl shadow-sm p-6">
            <h3 class="text-lg font-semibold text-gray-900 mb-6">Risk Assessment</h3>
            <ng-container *ngIf="risk; else noRisk">
                <div class="space-y-6">
                    <div class="text-center">
                        <div class="w-24 h-24 mx-auto bg-gradient-to-br from-green-100 to-green-200 rounded-full flex items-center justify-center mb-4">
                            <i-lucide name="shield" class="h-12 w-12 text-green-600"></i-lucide>
                        </div>
                        <h4 class="text-xl font-bold text-gray-900">{{ risk.label }}</h4>
                        <!-- <p class="text-gray-600">Diversification: {{ risk.diversification }}</p> -->
                    </div>
                    <div class="space-y-3">
                        <div class="flex justify-between">
                            <span class="text-gray-600">Risk Score</span>
                            <!-- <span class="text-gray-800 font-semibold">{{ risk.riskScore }}/10</span> -->
                            <span class="text-gray-800 font-semibold">8.5/10</span>

                        </div>
                        <div class="flex justify-between">
                            <span class="text-gray-600">Volatility</span>
                            <span class="text-gray-800 font-semibold">{{ risk.volatility }}</span>
                        </div>
                        <div class="flex justify-between">
                            <span class="text-gray-600">Diversification</span>
                            <span class="font-semibold text-green-600">{{ risk.diversification }}</span>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #noRisk>
                <div class="text-gray-500">No risk data available.</div>
            </ng-template>
        </div>

    </div>
</div>